import React from "react";
import FixOpenQuantities from "../../systemAdminModules/fixOpenQuantities/FixOpenQuantities";

const fixOpenQuantities = {
  path: "fix-open-quantities",
  sideNav: {
    group: 4,
    order: 71,
    label: "Audit Open Quantities",
    entityType: "all",
    allowedRole: ["admin", "auditor"],
    auth: ["authenticated"],
  },
  route: {
    index: {
      element: <FixOpenQuantities />,
      allowedRole: ["admin", "auditor"],
      entityType: "all",
      auth: ["authenticated"],
    },
  },
};

export default fixOpenQuantities;
